import React from "react";
export default function ButtonIcon(props) {
  return (
    <a
      style={{ display: "block" }}
      class={"btn-floating float-btn btn-small waves-effect waves-light add_item ml-auto mb-1"+(props.buttonType=="add"?" green ": " red ")}
      onClick={props.addRemoveFunc}
    >
      <i class="material-icons">{props.buttonType == "add" ? "add" : "clear" }</i>
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/components/Costing/Button/ButtonIcon/index.js